import React from 'react';
import { isAnchorTagAtBeginning } from './alert-description-helper';
import { AnchorAtStartCustomAlertContainer } from './anchor-at-start-custom-alert/container';
import { AnchorEmbeddedCustomAlertContainer } from './anchor-embedded-custom-alert/container';
import PropTypes from 'prop-types';

export const AutomationRuleAction = ({ salesOrderID, orderNumber, content }) => {
  const isAnchorAtBeginning = isAnchorTagAtBeginning(content);
  if (isAnchorAtBeginning) {
    return <AnchorAtStartCustomAlertContainer content={content} orderNumber={orderNumber} salesOrderID={salesOrderID} />;
  }
  return <AnchorEmbeddedCustomAlertContainer content={content} orderNumber={orderNumber} salesOrderID={salesOrderID} />;
};

AutomationRuleAction.propTypes = {
  salesOrderID: PropTypes.string.isRequired,
  orderNumber: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
};
